import { render, staticRenderFns } from "./InlineMailingAddress.vue?vue&type=template&id=388e0dfb&scoped=true&"
import script from "./InlineMailingAddress.vue?vue&type=script&lang=js&"
export * from "./InlineMailingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e0dfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388e0dfb')) {
      api.createRecord('388e0dfb', component.options)
    } else {
      api.reload('388e0dfb', component.options)
    }
    module.hot.accept("./InlineMailingAddress.vue?vue&type=template&id=388e0dfb&scoped=true&", function () {
      api.rerender('388e0dfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/InlineMailingAddress.vue"
export default component.exports